import React from "react";
import { whyChooseUsData } from "@/data";
// import { Col, Container, Row } from "react-bootstrap";

const AboutWhyChooseUs = () => {
  
  return (
    <section className="aboutWhyChooseUs">
      <div className="container">
        <div className="row g-0 mainCardWrapper">
          {/* Left card - WHY CHOOSE US */}
          <div className="col-md-9 p-0 whyChooseCard">
            <div className="contentWrapper h-100 d-flex align-items-center justify-content-start">
              <h2 className="fw-bold text-center">WHY CHOOSE US?</h2>
            </div>
          </div>

          {/* Right card - Quality */}
          <div className="col-md-3 p-0">
            <div className="contentCard qualityCard">
              <div className="cardBody text-center">
                <i className="fas fa-award cardIcon mb-3"></i>
                <h5 className="fw-bold">Quality</h5>
                <p className="text">
                  Our PVC sections are manufactured with the highest & superior
                  quality materials and craftsmanship.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom row - 4 cards */}
          {whyChooseUsData?.map((card, index) => (
            <div key={index} className="col-md-3 col-sm-6 p-0">
              <div className="contentCard">
                <div className="cardBody text-center">
                  <i className={`${card.icon} cardIcon mb-3`}></i>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text">{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutWhyChooseUs;
